/**
 * TeamStrip.jsx - Team Distribution Visualization
 * Phase 3B - Named export only
 */

import React from 'react';

export const TeamStrip = ({ roster }) => {
  const teams = roster.filter(s => s.player).map(s => s.player.team);
  const uniqueTeams = [...new Set(teams)];

  return (
    <div className="flex gap-1 mt-1 flex-wrap">
      {uniqueTeams.map(team => (
        <span
          key={team}
          className="text-[10px] font-bold text-slate-600 bg-slate-100 px-2 py-0.5 rounded"
        >
          {team}
        </span>
      ))}
      {uniqueTeams.length === 0 && (
        <span className="text-[10px] text-slate-400">No teams selected</span>
      )}
    </div>
  );
};
